import React, {useEffect, useState} from 'react'
import RecurrencePattern from './RecurrencePattern'
import Scheduler, {
  LAYOUT_TYPE_HORIZONTAL,
  LAYOUT_TYPE_VERTICAL
} from './Scheduler/Scheduler'
import {useRecurrenceState} from '../../context/RecurrenceContext'
import {fetchMeetingRoomFreeBusy} from '../../api/reservations'
import {useMeetingState} from '../../context/MeetingContext'
import ErrorContainer from '../../components/ErrorContainer'
import styled from 'styled-components'
import {useViewFetch} from '../../utils/fetch'

const MeetingSchedule = ({
  errors,
  meeting,
  setMeetingTime,
  workDates,
  room,
  onUpdateMeeting
}) => {
  const recurrence = useRecurrenceState()
  const {search} = useMeetingState()

  const isMobile = window.matchMedia('(max-width:420px)')
  const isTablet = window.matchMedia('(max-width:720px)')

  const isPortraitMode = () => {
    return window.orientation === 0 || window.orientation === 180
  }

  let layout = LAYOUT_TYPE_HORIZONTAL
  if (isPortraitMode() && (isMobile.matches || isTablet.matches)) {
    layout = LAYOUT_TYPE_VERTICAL
  }

  const [scheduleLayout, setScheduleLayout] = useState(layout)

  const orientationChange = () => {
    let layout = LAYOUT_TYPE_HORIZONTAL
    if (!isPortraitMode() && isTablet.matches) {
      layout = LAYOUT_TYPE_HORIZONTAL
    } else if (isPortraitMode()) {
      layout = LAYOUT_TYPE_VERTICAL
    }
    setScheduleLayout(layout)
  }

  const {data: scheduleDates} = useViewFetch({
    api: fetchMeetingRoomFreeBusy,
    parameters: {room},
    onChangeOf: [room],
    initialState: []
  })

  useEffect(
    () => {
      window.addEventListener('orientationchange', orientationChange, false)

      return () => {
        window.removeEventListener('orientationchange', orientationChange)
      }
    },
    [orientationChange]
  )

  return (
    <>
      <RecurrencePattern />
      <StyledErrors>
        <ErrorContainer errorMessage={errors} />
      </StyledErrors>
      <Scheduler
        layout={scheduleLayout}
        recurrence={recurrence}
        scheduleDates={scheduleDates}
        meeting={meeting}
        onChange={setMeetingTime}
        searchFilter={search}
        workDates={workDates}
        onUpdateMeeting={onUpdateMeeting}
      />
    </>
  )
}

export default MeetingSchedule

const StyledErrors = styled.div`
  padding: 6px 0 0 40px;
  user-select: none;
`
